import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {useSelector, useDispatch} from 'react-redux'
import { onGetMinaChild } from 'actions'
import { isEmpty } from 'lodash'

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));


function MinaChildKonto(props) {
    const dispatch = useDispatch()
    const classes = useStyles();
    const [orderAfid, setOrderAfid] = React.useState(props.OrderAfid);
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const ChildList = useSelector(state => state.accountsData.ChildList)
    const Kontonamn = useSelector(state => state.accountsData.currentAccount.name)

    React.useEffect(()=>{
        setOrderAfid(props.OrderAfid)
    },[props.OrderAfid])
    React.useEffect(()=>{
        dispatch(onGetMinaChild(Afid))
    },[])
    return (
        <form className={classes.root}>
        <div>
            <TextField
                select
                label="Konto:"
                variant="outlined"
                name="OrderAfid"
                size="small"
                value={orderAfid}
                fullWidth
                onChange={props.onChangenOrderAfid}
                SelectProps={{
                    native: true,
                }}
                InputLabelProps={{
                    shrink: true,
                  }}
            >
                <option key={Afid} value={Afid}>
                        {Kontonamn}
                </option>
                {
                isEmpty(ChildList)?"":
                ChildList.map((option) => (
                    <option key={option.ChildAfid} value={option.ChildAfid}>
                        {option.name}
                    </option>
                ))}
            </TextField>
        </div>
    </form>
    );
}

export default MinaChildKonto;